import { render, staticRenderFns } from "./single-department.vue?vue&type=template&id=16f61a15&"
import script from "./single-department.vue?vue&type=script&lang=js&"
export * from "./single-department.vue?vue&type=script&lang=js&"
import style0 from "./single-department.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports